export default __webpack_public_path__ + "static/media/gallery_01.6c16d982.jpg";